import { render, staticRenderFns } from "./MasterDataTableAction.vue?vue&type=template&id=3b64a001"
import script from "./MasterDataTableAction.vue?vue&type=script&lang=js"
export * from "./MasterDataTableAction.vue?vue&type=script&lang=js"
import style0 from "./MasterDataTableAction.vue?vue&type=style&index=0&id=3b64a001&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports